import servise from '@/router/axios'

export const setStatus = (data) => {
  return servise({
    url: '/report/reconciliation/state',
    method: 'PUT',
    data
  })
}

export const addInvoice = (data) => {
    return servise({
      url: '/reportCollect/add/bill/file/url',
      method: 'PUT',
      data
    })
  }

  export const upDataOdd = (data) => {
    return servise({
      url: '/reportCollect/modify/update/odd',
      method: 'PUT',
      data
    })
  }